import SEOHead from '@/components/feature/SEOHead';
import NavbarEn from './components/NavbarEn';
import HeroEn from './components/HeroEn';
import AboutEn from './components/AboutEn';
import BusinessAreasEn from './components/BusinessAreasEn';
import PartnersEn from './components/PartnersEn';
import ContactEn from './components/ContactEn';
import FooterEn from './components/FooterEn';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeEnJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Fixcope',
    url: `${siteUrl}/en`,
    logo: `${siteUrl}/logo.png`,
    description: 'Fixcope is a global technology solution company delivering machine vision, micro industrial cameras, medical equipment supply, and overseas expansion consulting.',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+82-2-2264-2563',
      contactType: 'customer service',
      email: 'info@fixcope.com',
      availableLanguage: ['Korean', 'English'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Fixcope | Global Technology Solution Partner',
    url: `${siteUrl}/en`,
    inLanguage: 'en',
    description: 'Fixcope connects the world through technology and trust. Machine vision, micro cameras, medical equipment, and global expansion consulting.',
  },
];

export default function HomeEnPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Fixcope | Global Technology Solution Partner - Machine Vision & Medical Equipment"
        description="Fixcope connects the world through technology and trust. We deliver machine vision inspection, micro industrial cameras, Korean medical equipment supply, and overseas expansion consulting."
        keywords="Fixcope, global solution partner, machine vision, industrial camera, medical equipment, overseas expansion consulting, technology solutions Korea"
        canonical="/en"
        ogTitle="Fixcope | Global Technology Solution Partner"
        ogDescription="Connecting the world through technology and trust. Machine vision, medical equipment, and global expansion consulting."
        lang="en"
        jsonLd={homeEnJsonLd}
      />
      <NavbarEn />
      <HeroEn />
      <AboutEn />
      <BusinessAreasEn />
      <PartnersEn />
      <ContactEn />
      <FooterEn />
    </div>
  );
}
